export var defaultImageProps = {
    className: '',
    src: '',
    prefix: 'img',
    enableWebp: false,
    onLoad: function (src) { },
    onError: function (src) { },
    fallback: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURQAAAKd6PdoAAAABdFJOUwBA5thmAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==',
};
export var defaultJDImageProps = {
    className: '',
    quality: 100,
    src: '',
    prefix: 'img',
    enableWebp: true,
    onLoad: function (src) { },
    onError: function (src) { },
    businessName: 'img',
    fallback: 'https://img13.360buyimg.com/schoolbt/jfs/t1/144559/13/12982/524/5fa10192E8bc182e1/e920f2a83550b301.png',
};
